




































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/asdcom/BaseComponent';
import util from '@/lib/util';
import AttachmentComponent from "@/components/vcponlineok/staff-user/attachments/attachments-list-component.vue";
import { 
  VcClaimChangeDto, 
  IVcClaimChangeDto, 
  ResponseToApplicantRequestDto, 
  ApplicantRequestTaskDto, 
  SubmissionStatus, 
  IApplicantRequestTaskDto, 
  ApplicantRequestTaskDtoOfVcClaimAccessRequestDto, 
  UserSubmissionType, 
  ApplicantRequestTaskDtoOfPersonalInfoDto,
  ApplicantRequestTaskDtoOfContactInfoChangeDto
} from '@/asdcom/apiproxy/apiproxy.dto';


@Component({
  components: {
    AttachmentComponent
  }
})
export default class ApplicantRequest extends BaseComponent {
  loading: boolean = false;
  requestApprovalStatuses: any[] = [];
  responseInputModel = new ResponseToApplicantRequestDto();
  requestModel: any = {};

  @Prop({default: () => null})
   viewModel: IApplicantRequestTaskDto;

  created() {
    this.getRequestDetails();
  }

  get isPersonalInfoChangeRequest() {
    if (this.requestModel.requestType == util.abp.constant.userSubmissionType.personalInfoChange) {
      return true;
    } else {return false;}
  }

  get isContactInfoChangeRequest() {
    if (this.requestModel.requestType == util.abp.constant.userSubmissionType.applicantContactChange) {
      return true;
    } else {return false;}
  }

  get isClaimAccessRequest() {
    if (this.requestModel.requestType == util.abp.constant.userSubmissionType.claimAccessRequest) {
      return true;
    } else {return false;}
  }

  get getStatus() {
    return this.getConstName("submissionStatus", this.requestModel.submissionStatus)
  }

  get getNewFullName() {
      return this.getFullName(
        this.requestModel.submissionData.prefix,
        this.requestModel.submissionData.firstName, 
        this.requestModel.submissionData.middleName,
        this.requestModel.submissionData.lastName,
        this.requestModel.submissionData.suffix
      )
  }

  get title() {
    if (this.viewModel.requestType == util.abp.constant.userSubmissionType.applicantContactChange) {
      return "Contact Information update"
    } else if (this.viewModel.requestType == util.abp.constant.userSubmissionType.personalInfoChange) {
      return "Personal Information update"
    } else {
      return "Claim Access"
    }
  }

  get hasAttachments() {
    const requestType = this.requestModel.requestType;
    if (requestType == UserSubmissionType.ClaimAccessRequest) {
      if (!!this.requestModel &&
          !!this.requestModel.submissionData &&
          !!this.requestModel.submissionData.attachments && 
          this.requestModel.submissionData.attachments.length > 0
        ) {
          return true;
      } else {
        return false;
      }
    }
  }

  @Watch("viewModel")
  async getRequestDetails() {
    abp.log.debug({"applicant-request-component requestType":this.viewModel.requestType});

    const requestType = this.viewModel.requestType;
    if (requestType == UserSubmissionType.ClaimAccessRequest) {
      this.requestModel = await this.$appsvs.vcpOnlineOkStaff.retrieveApplicantClaimAccessRequestDetails(this.viewModel.itemId);
    } else if (requestType == UserSubmissionType.PersonalInfoChange) {
      this.requestModel = await this.$appsvs.vcpOnlineOkStaff.retrieveApplicantPersonalInfoChangeDetails(this.viewModel.itemId);
    } else if (requestType == UserSubmissionType.ApplicantContactChange) {
      this.requestModel = await this.$appsvs.vcpOnlineOkStaff.retrieveApplicantContactInfoChangeDetails(this.viewModel.itemId);
    }
    this.requestApprovalStatuses = [];
    this.responseInputModel.status = this.requestModel.submissionStatus;
    this.responseInputModel.responseNote = this.requestModel.responseNote;
    this.requestModel.applicableSubmissionStatusList.forEach((i: number) => {
      this.requestApprovalStatuses.push(util.abp.constant.submissionStatus.values[i])
    })
  }

  async onSave() {
    this.loading = true;
    this.responseInputModel.itemId = this.viewModel.itemId;
    this.$appsvs.vcpOnlineOkStaff.submitResponseToApplicantRequest(this.responseInputModel)
    .then((res: any) => {
      this.$appsvs.vcpOnlineOkStaff.retrieveAndCachApplicantRequests();
      this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
      // this.$appsvs.globalEventsService.applicantRequestChanged();
      this.$emit("onClose");
      this.loading = false;

    })
  }
}
